"use strict";
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        /** Set this flag to true if when a large number of changes are being made to the UI. */
        ui.updating = $dyn.observable(false);
        ui.layout = $dyn.observable(false);
        ui.typeAheadTimer = 450;
        /** Defines whether the text, the image, or both should be displayed on the button. */
        var ButtonDisplay;
        (function (ButtonDisplay) {
            ButtonDisplay["textOnly"] = "TextOnly";
            ButtonDisplay["imageOnly"] = "ImageOnly";
            ButtonDisplay["textWithImageAbove"] = "TextWithImageAbove";
            ButtonDisplay["textWithImageBelow"] = "TextWithImageBelow";
            ButtonDisplay["textWithImageLeft"] = "TextWithImageLeft";
            ButtonDisplay["textWithImageRight"] = "TextWithImageRight";
            ButtonDisplay["backgroundImage"] = "BackgroundImage";
        })(ButtonDisplay = ui.ButtonDisplay || (ui.ButtonDisplay = {}));
        /** Different button styles. */
        var ButtonStyle;
        (function (ButtonStyle) {
            ButtonStyle["none"] = "";
            ButtonStyle["commandLink"] = "CommandLink";
            ButtonStyle["link"] = "Link";
        })(ButtonStyle = ui.ButtonStyle || (ui.ButtonStyle = {}));
        var ChangeMode;
        (function (ChangeMode) {
            /** Value changed event is raised only when the value is changed. This is the default behavior. */
            ChangeMode[ChangeMode["modified"] = 0] = "modified";
            /**
             * Value changed event is raised when the user has made any edits to an input field, even if the
             * new value is equal to the old value. This is applicable for input controls.
             */
            ChangeMode[ChangeMode["dirty"] = 1] = "dirty";
        })(ChangeMode = ui.ChangeMode || (ui.ChangeMode = {}));
        /** Indicates the kind of image. */
        var ImageType;
        (function (ImageType) {
            ImageType["symbol"] = "Symbol";
            ImageType["url"] = "URL";
            ImageType["base64"] = "Base64";
            /** @internal */
            ImageType["_axResource"] = "AOTResource";
        })(ImageType = ui.ImageType || (ui.ImageType = {}));
        var SortDirection;
        (function (SortDirection) {
            SortDirection[SortDirection["none"] = -1] = "none";
            SortDirection[SortDirection["ascending"] = 0] = "ascending";
            SortDirection[SortDirection["descending"] = 1] = "descending";
        })(SortDirection = ui.SortDirection || (ui.SortDirection = {}));
        var GridLines;
        (function (GridLines) {
            GridLines["Auto"] = "Auto";
            GridLines["None"] = "None";
            GridLines["Vertical"] = "Vertical";
            GridLines["All"] = "All";
        })(GridLines = ui.GridLines || (ui.GridLines = {}));
        var SignDisplayType;
        (function (SignDisplayType) {
            SignDisplayType["None"] = "None";
            SignDisplayType["Prefixed"] = "Prefixed";
            SignDisplayType["Suffixed"] = "Suffixed";
            SignDisplayType["Parentheses"] = "Parentheses";
            SignDisplayType["Auto"] = "Auto";
        })(SignDisplayType = ui.SignDisplayType || (ui.SignDisplayType = {}));
        var ThousandSeparator;
        (function (ThousandSeparator) {
            ThousandSeparator["comma"] = "Comma";
            ThousandSeparator["space"] = "Space";
            ThousandSeparator["apostrophe"] = "Apostrophe";
            ThousandSeparator["dot"] = "Dot";
            ThousandSeparator["none"] = "None";
            ThousandSeparator["auto"] = "Auto";
        })(ThousandSeparator = ui.ThousandSeparator || (ui.ThousandSeparator = {}));
        var DecimalSeparator;
        (function (DecimalSeparator) {
            DecimalSeparator["comma"] = "Comma";
            DecimalSeparator["dot"] = "Dot";
            DecimalSeparator["auto"] = "Auto";
        })(DecimalSeparator = ui.DecimalSeparator || (ui.DecimalSeparator = {}));
        var DateFormat;
        (function (DateFormat) {
            DateFormat["auto"] = "Auto";
            DateFormat["YMD"] = "YMD";
            DateFormat["YDM"] = "YDM";
            DateFormat["MYD"] = "MYD";
            DateFormat["MDY"] = "MDY";
            DateFormat["DYM"] = "DYM";
            DateFormat["DMY"] = "DMY";
        })(DateFormat = ui.DateFormat || (ui.DateFormat = {}));
        var ControlTypes;
        (function (ControlTypes) {
            ControlTypes["String"] = "Input";
            ControlTypes["Date"] = "Date";
            ControlTypes["DateTime"] = "DateTime";
            ControlTypes["Time"] = "Time";
            ControlTypes["Integer"] = "Integer";
            ControlTypes["Int64"] = "Int64";
            ControlTypes["Real"] = "Real";
            ControlTypes["Enum"] = "Enum";
            ControlTypes["Guid"] = "Guid";
            ControlTypes["ComboBox"] = "ComboBox";
        })(ControlTypes = ui.ControlTypes || (ui.ControlTypes = {}));
        ui.autoValue = "Auto";
        var DialogSize;
        (function (DialogSize) {
            DialogSize["small"] = "Small";
            DialogSize["medium"] = "Medium";
            DialogSize["large"] = "Large";
            DialogSize["full"] = "Full";
        })(DialogSize = ui.DialogSize || (ui.DialogSize = {}));
        var ReadyState;
        (function (ReadyState) {
            ReadyState["uninitialized"] = "uninitialized";
            ReadyState["request"] = "request";
            ReadyState["preloadRequest"] = "preloadRequest";
            ReadyState["preloading"] = "preloading";
            ReadyState["loading"] = "loading";
            ReadyState["ready"] = "ready";
            ReadyState["aborted"] = "aborted";
            ReadyState["closed"] = "closed";
        })(ReadyState = ui.ReadyState || (ui.ReadyState = {}));
        var FrameOptionButton;
        (function (FrameOptionButton) {
            FrameOptionButton["Hide"] = "Hide";
            FrameOptionButton["Radio"] = "Radio";
            FrameOptionButton["Check"] = "Check";
            FrameOptionButton["None"] = "None";
        })(FrameOptionButton = ui.FrameOptionButton || (ui.FrameOptionButton = {}));
        var TileType;
        (function (TileType) {
            TileType["standard"] = "Standard";
            TileType["link"] = "Link";
            TileType["count"] = "Count";
            TileType["kpi"] = "KPI";
        })(TileType = ui.TileType || (ui.TileType = {}));
        ui.TileFastestRetryFrequencyMilliseconds = 5000;
        ui.TileStandardRetryFrequencyMilliseconds = 600000;
        /**
         * Constant for the change event
         */
        ui.ChangeEvent = "dyn-change";
        /**
         * Constant for the change event
         */
        ui.ReadOnlyEvent = "dyn-readonly-event";
        /**
         * Constant for the string shown in password protected inputs
         */
        ui.PasswordString = "**********";
        var InputType;
        (function (InputType) {
            InputType[InputType["notSpecified"] = 0] = "notSpecified";
            InputType[InputType["mouse"] = 1] = "mouse";
            InputType[InputType["keyboard"] = 2] = "keyboard";
        })(InputType = ui.InputType || (ui.InputType = {}));
        var ScrollDirection;
        (function (ScrollDirection) {
            ScrollDirection[ScrollDirection["none"] = -1] = "none";
            ScrollDirection[ScrollDirection["up"] = 0] = "up";
            ScrollDirection[ScrollDirection["down"] = 1] = "down";
        })(ScrollDirection = ui.ScrollDirection || (ui.ScrollDirection = {}));
        /**
         * Corresponds to Event.which codes.
         */
        var MouseButtonCodes;
        (function (MouseButtonCodes) {
            MouseButtonCodes[MouseButtonCodes["leftButton"] = 1] = "leftButton";
            MouseButtonCodes[MouseButtonCodes["middleButton"] = 2] = "middleButton";
            MouseButtonCodes[MouseButtonCodes["rightButton"] = 3] = "rightButton";
        })(MouseButtonCodes = ui.MouseButtonCodes || (ui.MouseButtonCodes = {}));
        /**
         * Corresponds to Event.button codes.
         */
        var MouseEventButtonCodes;
        (function (MouseEventButtonCodes) {
            MouseEventButtonCodes.leftButton = 0;
            MouseEventButtonCodes.middleButton = 1;
            MouseEventButtonCodes.rightButton = 2;
            function fromMouseButtonCode(mouseButtonCode) {
                return mouseButtonCode - 1;
            }
            MouseEventButtonCodes.fromMouseButtonCode = fromMouseButtonCode;
        })(MouseEventButtonCodes = ui.MouseEventButtonCodes || (ui.MouseEventButtonCodes = {}));
        /**
         * Which status indicator to show
         */
        var StatusIndicator;
        (function (StatusIndicator) {
            StatusIndicator[StatusIndicator["none"] = 0] = "none";
            StatusIndicator[StatusIndicator["mandatory"] = 1] = "mandatory";
            StatusIndicator[StatusIndicator["warning"] = 2] = "warning";
        })(StatusIndicator = ui.StatusIndicator || (ui.StatusIndicator = {}));
        /**
         * Enum for the different CheckBox styles
         */
        var CheckBoxStyle;
        (function (CheckBoxStyle) {
            CheckBoxStyle["auto"] = "Auto";
            CheckBoxStyle["checkbox"] = "Checkbox";
            CheckBoxStyle["toggle"] = "Toggle";
        })(CheckBoxStyle = ui.CheckBoxStyle || (ui.CheckBoxStyle = {}));
        /**
         * The different styles tab pages can be.
         */
        var TabStyle;
        (function (TabStyle) {
            TabStyle["standard"] = "Tabs";
            TabStyle["vertical"] = "VerticalTabs";
            TabStyle["panorama"] = "Panorama";
            TabStyle["fasttab"] = "FastTab";
            TabStyle["droplist"] = "DropList";
        })(TabStyle = ui.TabStyle || (ui.TabStyle = {}));
        function tabWidth(control) {
            return $dyn.ui.autoProperty($dyn.layout.Size.available, control, "Width");
        }
        ui.tabWidth = tabWidth;
        function tabHeight(control) {
            return $dyn.ui.autoProperty($dyn.layout.Size.available, control, "Height");
        }
        ui.tabHeight = tabHeight;
        /**
         * Returns a computed that gets/sets the "Columns" property on the given control.
         * @internal
         * @param columnsValue
         * @param control The control to set the property on.
         */
        function columnsProperty(columnsValue, control) {
            return $dyn.computed(function () {
                var propertyValue = $dyn.value(control.Columns);
                if (propertyValue === $dyn.layout.Columns.fill) {
                    propertyValue = columnsValue;
                }
                return propertyValue;
            }, function (value) {
                $dyn.setValue(control, "Columns", value);
            });
        }
        ui.columnsProperty = columnsProperty;
        /**
         * Update a block while setting the appropriate observables to pause layout.
         * @param parentElement Element containing the block to update.
         * @param updateFunc Callback containing the logic to perform the block update.
         * @param thisArg this conext for updateFunc.
         */
        function updateBlock(parentElement, updateFunc, thisArg) {
            var wasUpdatingSet = false;
            if (!$dyn.peek($dyn.ui.updating)) {
                $dyn.ui.updating(true);
                wasUpdatingSet = true;
            }
            var layoutBlockSet = false;
            if (parentElement) {
                layoutBlockSet = $dyn.ui.layout();
                if (!layoutBlockSet) {
                    $dyn.ui.layout(true);
                }
            }
            updateFunc.call(thisArg);
            if (wasUpdatingSet) {
                $dyn.ui.updating(false);
            }
            if (parentElement) {
                // Need to queue the parent element for an arrange
                $dyn.layout.queueArrange(parentElement);
                if (!layoutBlockSet) {
                    $dyn.ui.layout(false);
                }
            }
        }
        ui.updateBlock = updateBlock;
        /**
         *  A sequential unique ID generator.
         */
        ui.uniqueId = 1;
        /**
         * Helper to set/clear an element's attribute.
         */
        function setAttribute(element, newValue, oldValue, attribute) {
            if (oldValue !== undefined) {
                if (newValue === undefined || newValue === null) {
                    element.removeAttribute(attribute);
                }
                else {
                    element.setAttribute(attribute, newValue);
                }
            }
        }
        ui.setAttribute = setAttribute;
        /**
         * Polyfill for document.selection, window.getSelection, document.getSelection.
         * @remarks Sometimes Edge will throw an exception when getting the document.selection. Ignore this exception.
         * @returns An object representing the range of text selected by the user or the current position of the caret.
         */
        function getSelection() {
            var selected;
            try {
                if (document.selection) {
                    selected = document.selection;
                }
                else if (window.getSelection) {
                    selected = window.getSelection();
                }
                else if (document.getSelection) {
                    selected = document.getSelection();
                }
            }
            catch (ignore) {
                // no-op: sometimes edge throws an exception getting the document.selection
            }
            return selected;
        }
        ui.getSelection = getSelection;
        /**
         * Wrapper for Element.selectionStart
         * @param targetElement The HTML Element.
         * @param value Act as a setter in addition to a getter.
         * @returns The index of the selection start
         */
        function selectionStart(targetElement, value) {
            try {
                if (targetElement) {
                    if (value || value === 0) {
                        targetElement.selectionStart = value;
                        return value;
                    }
                    else {
                        return targetElement.selectionStart;
                    }
                }
            }
            catch (e) {
                // Workaround for IE bug where selectionStart throws an exception. The reason it throws is unknown but seems
                // to only happen when an user holds the shift key down while clicking on 'non-hyperlinked' text in a grid.
                return 0;
            }
        }
        ui.selectionStart = selectionStart;
        /**
         * Wrapper for Element.selectionEnd
         * @param targetElement The HTML Element.
         * @param value Act as a setter in addition to a getter.
         * @returns The index of the selection end.
         */
        function selectionEnd(targetElement, value) {
            try {
                if (targetElement) {
                    if (value || value === 0) {
                        targetElement.selectionEnd = value;
                        return value;
                    }
                    else {
                        return targetElement.selectionEnd;
                    }
                }
            }
            catch (e) {
                // Workaround for IE bug where selectionEnd throws an exception. The reason it throws is unknown but seems
                // to only happen when an user holds the shift key down while clicking on 'non-hyperlinked' text in a grid.
                return 0;
            }
        }
        ui.selectionEnd = selectionEnd;
        /**
         * @deprecated
         */
        function stringAttributeSetter(attribute) {
            // TODO TFS:3745038 Dead
            $dyn.logDeprecated("$dyn.ui.stringAttributeSetter");
            return function (targetElement, newValue, lastValue) {
                if (newValue !== undefined && newValue !== null) {
                    // Data is set as the value on the element
                    targetElement.setAttribute(attribute, newValue);
                }
                else if (lastValue !== undefined && lastValue !== null) {
                    targetElement.removeAttribute(attribute);
                }
            };
        }
        ui.stringAttributeSetter = stringAttributeSetter;
        /**
         * @deprecated
         */
        function stringAttributeGetter(attribute) {
            // TODO TFS:3745038 Dead
            $dyn.logDeprecated("$dyn.ui.stringAttributeGetter");
            return function (targetElement) {
                return targetElement.getAttribute(attribute);
            };
        }
        ui.stringAttributeGetter = stringAttributeGetter;
        /**
         * @deprecated
         */
        function booleanAttributeSetter(attribute) {
            // TODO TFS:3745038 Dead?
            return function (targetElement, newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                if (!newValue) {
                    // Data is set as the value on the element
                    targetElement.removeAttribute(attribute);
                }
                else {
                    targetElement.setAttribute(attribute, "");
                }
            };
        }
        ui.booleanAttributeSetter = booleanAttributeSetter;
        function replaceCssClass(targetElement, newValue, lastValue) {
            if ($dyn.isObservable(lastValue)) {
                lastValue = $dyn.value(lastValue);
            }
            if (lastValue && targetElement) {
                targetElement.classList.remove(lastValue);
            }
            if ($dyn.isObservable(newValue)) {
                newValue = $dyn.value(newValue);
            }
            if (newValue && targetElement) {
                targetElement.classList.add(newValue);
            }
        }
        ui.replaceCssClass = replaceCssClass;
        /**
         * @deprecated
         */
        function toggleCssClass(targetElement, newValue, lastValue, cssClassName) {
            // TODO TFS:3745038 Dead?
            if ($dyn.isObservable(newValue)) {
                newValue = $dyn.value(newValue);
            }
            if (newValue) {
                targetElement.classList.add(cssClassName);
            }
            else {
                targetElement.classList.remove(cssClassName);
            }
        }
        ui.toggleCssClass = toggleCssClass;
        /**
         * @deprecated
         */
        function boolCssGetter(className) {
            $dyn.logDeprecated("$dyn.ui.boolCssGetter");
            return function (targetElement) {
                return targetElement.classList.contains(className);
            };
        }
        ui.boolCssGetter = boolCssGetter;
        /**
         * @deprecated
         */
        function boolCssSetter(className) {
            $dyn.logDeprecated("$dyn.ui.boolCssSetter");
            return function (targetElement, newValue, lastValue) {
                if (newValue) {
                    targetElement.classList.add(className);
                }
                else {
                    targetElement.classList.remove(className);
                }
            };
        }
        ui.boolCssSetter = boolCssSetter;
        /**
         * handles stripping out caption , click, title and formtype and returning to binder
         * @param formData the current form
         * @returns returns object with Caption, HeaderClicked, TitleFields and FormType
         */
        function formHeaderCreate(formData) {
            return $dyn.ui.controlOptions(function () {
                return {
                    Caption: formData.Caption,
                    FormType: formData.TypeName,
                    HeaderClicked: function () { formData.GoGridView(); },
                    TitleFields: formData.ParentTitleFields,
                };
            }, formData);
        }
        ui.formHeaderCreate = formHeaderCreate;
        // TODO: add typing for parameters
        function createControl(roleId, parameters, dataContext, tagName) {
            if (!tagName) {
                tagName = "div";
            }
            var targetElement = document.createElement(tagName);
            $dyn.ui.updateBlock(targetElement, function () {
                // The resource should already be loaded.
                targetElement.setAttribute("data-dyn-role", roleId);
                targetElement.dynOptions = parameters;
                $dyn.dataBind(targetElement, dataContext);
            });
            return targetElement;
        }
        ui.createControl = createControl;
        /**
         * Creates a child control under the specified parent control
         */
        function createChildControl(roleId, parameters, parentControlElement, createOptions) {
            var parentControl = $dyn.context(parentControlElement);
            if (!parentControl) {
                throw new TypeError("Parameter 'parentControl' is required");
            }
            if (!createOptions) {
                createOptions = {};
            }
            var tagName = createOptions.tagName;
            if (!tagName) {
                tagName = "div";
            }
            var index = createOptions.index;
            var targetElement;
            $dyn.ui.updateBlock(parentControlElement, function () {
                if (parentControl.Updating) {
                    parentControl.Updating(true);
                }
                targetElement = document.createElement(tagName);
                // The resource should already be loaded.
                targetElement.setAttribute("data-dyn-role", roleId);
                // check if createOptions includes class
                if (createOptions.class) {
                    targetElement.classList.add(createOptions.class);
                }
                targetElement.dynOptions = parameters;
                var childrenObservable = $dyn._getChildren(parentControl.element);
                if (!index) {
                    index = $dyn.length(childrenObservable);
                }
                parentControl.element.appendChild(targetElement);
                childrenObservable.set(index, targetElement);
                var parentRole = $dyn.role(targetElement.parentElement || targetElement);
                parentRole.dataBindChild(targetElement, parentControl.element.dynContext);
                childrenObservable.valueChanged.raise();
                if (parentControl.Children) {
                    parentControl.Children.valueChanged.raise();
                }
                if (parentControl.Updating) {
                    parentControl.Updating(false);
                }
            });
            return targetElement;
        }
        ui.createChildControl = createChildControl;
        /**
         * Remove focus from active element if it is contained by container or containers that are passed in.
         * @description Should be used before actions that would re-append the activeElement elsewhere, because IE does not handle the active element being reappended elsewhere gracefully.
         *              Without removing focus first, the document's active element will return the correct element, and $(':focus') will return the correct element,
         *              but no characters typed into that element will show up.
         *              Setting focus to that element also would do nothing because the element believes it already has focus.
         * @param containers The jQuery list of containers that will be layed out (One or more containers)
         * @returns Object containing the element that lost focus and its selection information
         */
        function removeFocus(containers) {
            var activeElement;
            try {
                // suppress the error since document.activeElement throws an exception in some IE versions
                activeElement = document.activeElement;
                // tslint:disable-next-line:no-empty
            }
            catch (e) { }
            if (activeElement && (containers === undefined || (containers.length && (containers.filter(activeElement).length > 0 || containers.has(activeElement).length > 0)))) {
                $dyn.log.focus && $dyn.log.focus("$dyn.ui.removeFocus from %s", activeElement.id);
                var oldValue = $dyn.shell.clearBodyFocusCorrection();
                $(activeElement).blur();
                $dyn.shell.bodyFocusCorrection = oldValue;
                return { element: activeElement, selectionStart: $dyn.ui.selectionStart(activeElement), selectionEnd: $dyn.ui.selectionEnd(activeElement) };
            }
        }
        ui.removeFocus = removeFocus;
        /**
         * Restore active element if it is changed. Callers of this function are responsible for storing the element that is returned from $dyn.ui.removeFocus,
         * and passing it into this function as the argument.
         * @param options The original document.activeElement or an object containing the original active element and its selection properties
         */
        function restoreFocus(options) {
            var element;
            var selectionStartIndex;
            var selectionEndIndex;
            var optionsAsObj = options;
            if (optionsAsObj.element) {
                element = optionsAsObj.element;
                selectionStartIndex = optionsAsObj.selectionStart;
                selectionEndIndex = optionsAsObj.selectionEnd;
            }
            else {
                element = options;
            }
            if (element && element !== document.activeElement && element.focus) {
                $dyn.log.focus && $dyn.log.focus("$dyn.ui.restoreFocus to %s", element.id);
                element.focus();
                if (element.value) {
                    var inputElement = element;
                    if ((selectionStartIndex || selectionEndIndex) === undefined) {
                        $dyn.ui.selectionStart(inputElement, inputElement.value.length);
                        $dyn.ui.selectionEnd(inputElement, inputElement.value.length);
                    }
                    else {
                        $dyn.ui.selectionStart(inputElement, selectionStartIndex);
                        $dyn.ui.selectionEnd(inputElement, selectionEndIndex);
                    }
                }
            }
        }
        ui.restoreFocus = restoreFocus;
        /**
         * Creates an instance of $dyn.ui.CssSelector
         * @internal
         */
        function selector() {
            return new $dyn.ui.CssSelector();
        }
        ui.selector = selector;
        /**
         * Represents an API to build CSS selectors dynamically
         * @internal
         * @example Example usage:
         * $dyn.ui.selector().id("TestId").css("testClass1").css("testChained").desc().tag("input").css("descendentClass")
         *      .child().attr("attributeOfChild", "attributeValue").nthChild(1);
         * The selector would be
         *      #TestId.testClass1.testChained input.descendentClass > [attributeOfChild="attributeValue"]:nth-child(1)
         * selector = $dyn.ui.selector().css("parent").attr("attribute-without-value").sibling().css("siblingOfParent").attr("attribute-of-sibling", "StartWithValue", "^=")
         *      .child().css("childOfParent").not($dyn.ui.selector().attr("attribute-with-null-value", null));
         * The selector would be
         *      .parent[attribute-without-value] + .siblingOfParent[attribute-of-sibling^="StartWithValue"] > .childOfParent:not([attribute-with-null-value=""])
         * Currently supports most of the CSS selector object model, when adding additional function, refer to the cssom specification.
         */
        var CssSelector = /** @class */ (function () {
            function CssSelector() {
                this._selectorString = "";
            }
            /**
             * @internal
             * @returns Return this instance of CssSelector class
             */
            CssSelector.prototype.id = function (id) {
                this._selectorString += "#" + this._serializeIdentifier(id);
                return this;
            };
            /**
             * @internal
             * @returns Return this instance of CssSelector class
             */
            CssSelector.prototype.tag = function (tag) {
                this._selectorString += this._serializeIdentifier(tag);
                return this;
            };
            /**
             * @internal
             * @returns Return this instance of CssSelector class
             */
            CssSelector.prototype.css = function (className) {
                this._selectorString += "." + this._serializeIdentifier(className);
                return this;
            };
            /**
             * @internal
             * @returns Return this instance of CssSelector class
             */
            CssSelector.prototype.desc = function () {
                // Descendant selector combinator
                this._selectorString += " ";
                return this;
            };
            /**
             * @internal
             * @returns Return this instance of CssSelector class
             */
            CssSelector.prototype.child = function () {
                this._selectorString += " > ";
                return this;
            };
            /**
             * @internal
             * @returns Return this instance of CssSelector class
             */
            CssSelector.prototype.sibling = function () {
                this._selectorString += " + ";
                return this;
            };
            /**
             * @internal
             * @returns Return this instance of CssSelector class
             */
            CssSelector.prototype.following = function () {
                this._selectorString += " ~ ";
                return this;
            };
            /**
             * @internal
             * @returns Return this instance of CssSelector class
             */
            CssSelector.prototype.nthChild = function (index) {
                if (!(index >= 0)) {
                    // Note: handles case when index is not a number
                    // Note: Doesn't currently allow the An+B microsyntax
                    throw new Error("index must be a number greater than or equal 0");
                }
                this._selectorString += ":nth-child(" + index + ")";
                return this;
            };
            /**
             * @internal
             * @param selectorToNot The selector to not
             * @returns Return this instance of CssSelector class
             */
            CssSelector.prototype.not = function (selectorToNot) {
                if (!(selectorToNot instanceof $dyn.ui.CssSelector)) {
                    throw new Error('Invalid value for argument "selector"');
                }
                this._selectorString += ":not(" + selectorToNot.toString() + ")";
                return this;
            };
            /**
             * @internal
             * @returns Return this instance of CssSelector class
             */
            CssSelector.prototype.attr = function (attributeName, value, operator) {
                var buildSelector = "[" + this._serializeIdentifier(attributeName);
                if (value !== undefined) {
                    if (operator) {
                        switch (operator) {
                            case "=":
                            case "~=":
                            case "|=":
                            case "^=":
                            case "$=":
                            case "*=":
                                break;
                            default:
                                operator = "=";
                        }
                    }
                    else {
                        operator = "=";
                    }
                    buildSelector += operator;
                    if (value === null) {
                        value = "";
                    }
                    else if (typeof value !== "string") {
                        value = value.toString();
                    }
                    buildSelector += '"' + this._serializeString(value) + '"';
                }
                buildSelector += "]";
                this._selectorString += buildSelector;
                return this;
            };
            /**
             * @internal
             * @returns Return the selector as a string
             */
            CssSelector.prototype.toString = function () {
                return this._selectorString;
            };
            /**
             * @internal
             * @param element The element to perform the selector on
             * @returns Returns the results of the querySelectorAll method
             */
            CssSelector.prototype.find = function (element) {
                // Note: Use the native selector API not the jQuery api (the jQuery expensive selectors such as :visible should be post processed by using filter)
                return element.querySelectorAll(this.toString());
            };
            /**
             * Implements the CSS Object Model (CSSOM) / CSS Working group specification of serializing CSS strings.
             * @returns The escaped string
             */
            CssSelector.prototype._serializeString = function (str) {
                var escapedStr = "";
                var doubleQuoteCharCode = 0x22;
                var backslashCharCode = 0x5c;
                var hasEscapedChar = false;
                for (var i = 0, len = str.length; i < len; i++) {
                    var charCode = str.charCodeAt(i);
                    if (charCode === 0) {
                        throw new Error("InvalidCharacterError");
                    }
                    if ((charCode >= 1 && charCode <= 0x1f) || // control codes
                        (charCode >= 0x7f && charCode <= 0x9f)) {
                        // extended control codes
                        if (!hasEscapedChar && i > 0) {
                            escapedStr = str.substring(0, i);
                        }
                        // When the character needs code point escaping - mainly control code chars
                        // Note: this should be untypical for identifier strings.
                        // The [optional] whitespace allows for hexadecimal escape sequences to be followed by "real" hex digits.
                        escapedStr += "\\" + charCode.toString(16) + " ";
                        hasEscapedChar = true;
                    }
                    else if (charCode === doubleQuoteCharCode || charCode === backslashCharCode) {
                        // Note: ' is not escaped because the string is always serialized with "
                        if (!hasEscapedChar && i > 0) {
                            // Optimized for when the front of the string is not encoded
                            escapedStr = str.substring(0, i);
                        }
                        escapedStr += "\\" + String.fromCharCode(charCode);
                        hasEscapedChar = true;
                    }
                    else {
                        if (hasEscapedChar) {
                            // Otherwise, the character itself
                            escapedStr += String.fromCharCode(charCode);
                        }
                    }
                }
                if (!hasEscapedChar) {
                    // Optimized for when there is no escaped characters the original string is returned
                    escapedStr = str;
                }
                return escapedStr;
            };
            /**
             * Implements the CSS Object Model (CSSOM) / CSS Working group specification of serializing CSS strings.
             * @returns The escaped identifier
             */
            CssSelector.prototype._serializeIdentifier = function (indentifier) {
                var escapedStr = "";
                var charCode;
                var escapedChar;
                var dashChar = 0x2d; // -
                var underscoreChar = 0x5f; // _
                var firstCharCode = indentifier.charCodeAt(0);
                var hasEscapedChar = false;
                for (var i = 0, len = indentifier.length; i < len; i++) {
                    charCode = indentifier.charCodeAt(i);
                    if (charCode === 0) {
                        throw new Error("InvalidCharacterError");
                    }
                    if ((charCode >= 1 && charCode <= 0x1f) || // control codes
                        (charCode >= 0x7f && charCode <= 0x9f) || // extended control codes
                        (i === 0 && charCode >= 0x30 && charCode <= 0x39) || // 0-9
                        (i === 1 && charCode >= 0x30 && charCode <= 0x39 && firstCharCode === dashChar)) {
                        // -0-9
                        if (!hasEscapedChar && i > 0) {
                            // Optimized for when the front of the string is not encoded
                            escapedStr = indentifier.substring(0, i);
                        }
                        escapedChar = "\\" + charCode.toString(16) + " ";
                        escapedStr += escapedChar;
                        hasEscapedChar = true;
                    }
                    else if (charCode >= 0x80 ||
                        charCode === dashChar ||
                        charCode === underscoreChar ||
                        (charCode >= 0x30 && charCode <= 0x39) || // 0-9
                        (charCode >= 0x41 && charCode <= 0x5a) || // A-Z
                        (charCode >= 0x61 && charCode <= 0x7a)) {
                        // a-z
                        if (hasEscapedChar) {
                            escapedStr += String.fromCharCode(charCode);
                        }
                    }
                    else {
                        if (!hasEscapedChar && i > 0) {
                            escapedStr = indentifier.substring(0, i);
                        }
                        escapedStr += "\\" + String.fromCharCode(charCode);
                        hasEscapedChar = true;
                    }
                }
                if (!hasEscapedChar) {
                    // Optimized for when there is no escaped characters the original string is
                    escapedStr = indentifier;
                }
                return escapedStr;
            };
            return CssSelector;
        }());
        ui.CssSelector = CssSelector;
        if (window.CSS && window.CSS.escape) {
            // Use the new native CSS escape function that is defined to be the same as the serialize identifier definition
            // Store the non-native function to help unit testing
            // tslint:disable-next-line:no-string-literal
            $dyn.ui.CssSelector.prototype["__serializeIdentifier"] = $dyn.ui.CssSelector.prototype["_serializeIdentifier"];
            // tslint:disable-next-line:no-string-literal
            $dyn.ui.CssSelector.prototype["_serializeIdentifier"] = window.CSS.escape;
        }
    })(ui = $dyn.ui || ($dyn.ui = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DynUI.js.map
